import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import objectPath from 'object-path';

import {GridContainer, GridCell} from '../../../../../components/grid';
import {paletteData, Button, Typography, Dialog, Fab, Input, Select} from '../../../../../components/styles';
import {LayoutEdit} from '../../../../../components/layout';

import HeaderForm from '../../../../../components/forms/header';

function EditEventLayoutSubPanel({
  me,
  focusedEvent,
  handleChangeFocusedEvent,
  processing,
  setProcessing
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(undefined);
  const [imageLibrary, setImages] = useState(undefined);
  const [page, setPage] = useState(0);

  useEffect(() => {
    if(!imageLibrary) {
      const gallery = focusedEvent.gallery;
      setImages(gallery);
    }
  }, [focusedEvent, imageLibrary]);

  const changePage = (page, type, index, path, value) => {
    if(type === 'insert') {
      const tempLayout = focusedEvent.layout || {
        header: {},
        multiPageEnabled: false,
        pages: [{
          title: 'home',
          sections: [],
        }],
      };
      if(!tempLayout.pages) {
        tempLayout.pages = [{
          title: 'home',
          sections: [],
        }];
      };
      tempLayout.pages[page].sections.splice(index, 0, value);
      handleChangeFocusedEvent('layout', tempLayout);
    } else if (type === 'update') {
      const tempLayout = focusedEvent.layout;
      if(path === undefined) {
        tempLayout.pages[page].sections = value;
      } else {
        if(path === '') {
          objectPath.set(tempLayout.pages[page].sections, `${index}`, value);
        } else {
          objectPath.set(tempLayout.pages[page].sections, `${index}.${path}`, value);
        }
      }
      handleChangeFocusedEvent('layout', tempLayout);
    }
  }

  const changeParent = (type, path, value) => {
    if(type === 'insert') {
      const tempArray = objectPath.get(focusedEvent, path) || [];
      tempArray.push(value);
      objectPath.set(focusedEvent, path, tempArray);
    }
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
      <div style={{background: paletteData.primary.standard.background, padding: 10}}>
        <GridContainer>
          <GridCell center={true}>
            <a
              href={`https://rerengatahi.nz/event/${focusedEvent._id}`}
              style={{textDecoration: 'none'}}
              target="_blank"
              rel='noopener noreferrer'
            >
              <Typography style={{color: paletteData.primary.standard.foreground}}>
                Layout
              </Typography>
            </a>
          </GridCell>
          <GridCell center={true}>
            <a
              href={`https://rerengatahi.nz/event/${focusedEvent._id}`}
              style={{textDecoration: 'none'}}
              target="_blank"
              rel='noopener noreferrer'
            >
              <span className="material-icons md-24" style={{color: paletteData.primary.standard.foreground, marginLeft: 5}}>visibility</span>
            </a>
          </GridCell>
          <GridCell weight={1}/>

          {focusedEvent?.layout?.multiPageEnabled &&
            <GridCell center={true}>
              <Select
                style={{minWidth: 100}}
                palette='primary'
                label="Page Index"
                value={page}
                onChange={(value) => setPage(value)}
              >
                {focusedEvent?.layout?.pages?.length > 0 && focusedEvent.layout.pages.map((p, pIndex) => (
                  <option key={pIndex} value={pIndex} style={{color: 'black'}}>{pIndex + 1}</option>
                ))}
              </Select>
            </GridCell>
          }
          {focusedEvent?.layout?.multiPageEnabled &&
            <GridCell center={true}>
              <Input
                palette='primary'
                label="Page Title"
                value={focusedEvent?.layout?.pages[page]?.title}
                onChange={(value) => {
                  const layoutProcessed = focusedEvent.layout;
                  layoutProcessed.pages[page].title = value;
                  handleChangeFocusedEvent('layout', layoutProcessed);
                }}
              />
            </GridCell>
          }
          {focusedEvent?.layout?.multiPageEnabled && page !== 0 &&
            <GridCell center={true}>
              <Fab
                size='small'
                onClick={() => {
                  setDialogData({
                    type: 'messageWithCallback',
                    title:  'Delete Page',
                    message: 'Deleting a page is perminant are you sure you wish to proceed?',
                    data: {
                      callback: () => {
                        const layoutProcessed = focusedEvent?.layout || {pages: []};
                        layoutProcessed.pages.splice(page, 1);
                        handleChangeFocusedEvent('layout', layoutProcessed);
                        setPage(page - 1);
                      }
                    },
                  });
                  setDialogOpen(true);
                }}
              >
                <span className="material-icons md-24" style={{color: paletteData.primary.standard.foreground}}>delete_sweep</span>
              </Fab>
            </GridCell>
          }
          {focusedEvent?.layout?.multiPageEnabled &&
            <GridCell center={true}>
              <Fab
                size='small'
                onClick={() =>{
                  setDialogData({
                    type: 'movePage',
                    title:  'Move Page',
                    data: {
                      currentIndex: page,
                    },
                    value: {
                      index: page,
                      humanIndex: (page + 1),
                    },
                  });
                  setDialogOpen(true);
                }}
              >
                <span className="material-icons md-24" style={{color: paletteData.primary.standard.foreground}}>move_down</span>
              </Fab>
            </GridCell>
          }
          {focusedEvent?.layout?.multiPageEnabled &&
            <GridCell center={true}>
              <Fab
                size='small'
                onClick={() =>{
                  const layoutProcessed = focusedEvent?.layout || {pages: []};
                  const newIndex = focusedEvent?.layout?.pages?.length;
                  const page = {
                    title: `page ${newIndex}`,
                    sections: [],
                  }
                  layoutProcessed.pages.push(page);
                  handleChangeFocusedEvent('layout', layoutProcessed);
                  setPage(newIndex);
                }}
              >
                <span className="material-icons md-24" style={{color: paletteData.primary.standard.foreground}}>note_add</span>
              </Fab>
            </GridCell>
          }
          <GridCell center={true}>
            <Fab
              size='small'
              onClick={() =>{
                const layoutProcessed = focusedEvent.layout;
                layoutProcessed.multiPageEnabled = !(layoutProcessed.multiPageEnabled || false);
                handleChangeFocusedEvent('layout', layoutProcessed);
                if(layoutProcessed.multiPageEnabled === false) {
                  setPage(0);
                }
              }}
            >
              {focusedEvent?.layout?.multiPageEnabled && <span className="material-icons md-24" style={{color: paletteData.primary.standard.foreground}}>layers</span>}
              {!focusedEvent?.layout?.multiPageEnabled && <span className="material-icons md-24" style={{color: paletteData.primary.standard.foreground}}>layers_clear</span>}
            </Fab>
          </GridCell>
        </GridContainer>
      </div>

      <LayoutEdit
        imageLibrary={imageLibrary}
        videoLibrary={focusedEvent?.videoLibrary || []}
        sections={(focusedEvent?.layout?.pages && focusedEvent?.layout?.pages[page]?.sections) || []}
        changeSection={(type, index, path, value) => changePage(page, type, index, path, value)}
        changeParent={(type, path, value) => changeParent(type, path, value)}
      />

      {/*popouts and popups*/}
      {dialogOpen &&
        <Dialog
          open={dialogOpen}
          handleClose={() => {
           setDialogData(undefined);
           setDialogOpen(false);
         }}
        >
          <div style={{padding: 10, textAlign: 'center', background: paletteData.primary.standard.background}}>
            <Typography size='title' style={{color: paletteData.primary.standard.foreground}}>
              {dialogData?.title}
            </Typography>
          </div>
          {(dialogData?.message) &&
            <div style={{padding: 10}}>
              <Typography>
                {dialogData.message}
              </Typography>
            </div>
          }
          {dialogData?.type === 'editHeader' &&
            <div style={{padding: 10}}>
              <HeaderForm
                header={dialogData?.value || {}}
                handleChange={(name, value) => {
                  setDialogData({
                    ...dialogData,
                    value: {
                      ...dialogData.value,
                      [name]: value,
                    },
                  });
                }}
                processing={processing}
              />
            </div>
          }
          {dialogData?.type === 'movePage' &&
            <div style={{padding: 10}}>
              <Input
                type='number'
                label='New Index'
                value={dialogData?.value?.index}
                onChange={(value) => {
                  setDialogData({
                    ...dialogData,
                    value: {
                      ...(dialogData.value || {}),
                      index: value - 1,
                      humanIndex: value,
                    }
                  });
                }}
              />
            </div>
          }
          <GridContainer>
            <GridCell weight={1}/>
            <GridCell style={{padding: 10}}>
              <Button
                palette='primary'
                 onClick={() => {
                  setDialogData(undefined);
                  setDialogOpen(false);
                }}
              >
                {dialogData?.type === 'message' ? 'OK' : 'Cancel'}
              </Button>
            </GridCell>
            {dialogData?.type === 'editHeader' &&
              <GridCell style={{padding: 10}}>
                <Button
                  palette='primary'
                   onClick={() => {
                     const tempLayout = {
                       ...focusedEvent.layout,
                       header: dialogData?.value,
                     };
                     handleChangeFocusedEvent('layout', tempLayout);
                     setDialogData(undefined);
                     setDialogOpen(false);
                  }}
                >
                  Edit Header
                </Button>
              </GridCell>
            }
            {dialogData?.type === 'messageWithCallback' &&
              <GridCell style={{padding: 10}}>
                <Button
                  palette='primary'
                   onClick={() => {
                     dialogData?.data?.callback();
                     setDialogData(undefined);
                     setDialogOpen(false);
                  }}
                >
                  Submit
                </Button>
              </GridCell>
            }
          </GridContainer>
        </Dialog>
      }
    </div>
  );
};

EditEventLayoutSubPanel.propTypes = {
  me: PropTypes.shape({}),
  focusedEvent: PropTypes.shape({}),
  handleChangeFocusedEvent: PropTypes.func,
  processing: PropTypes.bool,
  setProcessing: PropTypes.func,
};

export default EditEventLayoutSubPanel;
